<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md last-update" v-bind:class="{'text-right': window.isMobile != true,'text-center': window.isMobile == true}">{{$t('UpdateTime')}}{{lastUpdate}}</div>
      </div>
      
      <div class="row">
        <div class="col-md text-center control-type-button">
            <b-button-group>
                <b-button size="sm" 
                    v-for="btn in options" 
                    :key="btn.value" 
                    v-on:click="currentMode = btn.value"  :variant="currentMode == btn.value ? 'info' : ''"
                    v-b-tooltip.hover :title="$t('button.'+btn.value+'.title')" placement="bottom"
                    >
                    {{$t('button.'+btn.value+'.text')}}
                </b-button>
            </b-button-group>
        </div>
      </div>
     
      <div class="row">
            <div class="col-md control-button" v-bind:class="{'text-right': !window.isMobile, 'text-center': window.isMobile}">
                <button type="button" class="btn btn-control" @click="simpleMode = !simpleMode">
                    <i class="fas fa-angle-double-down" v-bind:class="{'fa-angle-double-down': simpleMode==true, 'fa-angle-double-up':simpleMode==false}"></i>{{simpleMode?$t("AllTaiwan.EnableMore"):$t("AllTaiwan.DisableMore")}}
                </button>
                <button type="button" class="btn btn-control" v-on:click="print" v-if="window.isMobile != true">
                    <i class="material-icons">print</i> {{$t("AllTaiwan.Print")}}
                </button>
            </div>
      </div>
      <div class="row">
        
        <AllTWComponent isNeededShowLegend=true series="RODS_NHI"
          :simpleMode="simpleMode"
          :WeekSelectValue="WeekSelectValue"
          @ChangedWeekSelectValue="onWeekSelectValue"
          @getChartReal="getChartReal"
          @getChartForecast="getChartForecast"
          @getLag1Backtest="getLag1Backtest"
          @getLast4Week="getLast4Week"
          v-bind:class="{'hide': currentMode != 'RODS_NHI' && window.isMobile}"
        ></AllTWComponent>
        <AllTWComponent series="NHI" 
          :simpleMode="simpleMode"
          :WeekSelectValue="WeekSelectValue"
          @ChangedWeekSelectValue="onWeekSelectValue"
          @getChartReal="getChartReal"
          @getChartForecast="getChartForecast"
          @getLag1Backtest="getLag1Backtest"
          @getLast4Week="getLast4Week"
          v-bind:class="{'hide': currentMode != 'NHI' && window.isMobile}"
        ></AllTWComponent>
        <AllTWComponent series="RODS" 
          :simpleMode="simpleMode"
          :WeekSelectValue="WeekSelectValue"
          @ChangedWeekSelectValue="onWeekSelectValue"
          @getChartReal="getChartReal"
          @getChartForecast="getChartForecast"
          @getLag1Backtest="getLag1Backtest"
          @getLast4Week="getLast4Week"
          v-bind:class="{'hide': currentMode != 'RODS' && window.isMobile}"
        ></AllTWComponent>
      </div>
    </div>

    


    <div class="print">
      <div class="container" id="containter">
        <div class="row project-name">
            <div class="col-sm-12 title">{{$t("Navbar.WebSiteName")}}</div>
            <div class="col-sm-12 update-time">{{$t("UpdateTime")}}{{lastUpdate}}</div>
        </div>
        <div class="row item" v-for="(item, index) in Data" v-if="item.isReady">
            <div class="col-sm-12 title">{{item.label}}</div>
            <div class="col-sm-8">
                <div class="forecast-4-week-table">
                    <div class="describe">{{$t("Share.PredictOfNext4Week")}}</div>
                    <table>
                        <thead>
                            <tr v-if="item.last4Week">
                                <td class="">{{$t('Share.ModelName')}}</td>
                                <td v-for="(subItem) in item.last4Week">{{subItem.Model}}</td>
                            </tr>
                        </thead>
                        <tbody v-if="item.last4Week">
                            <tr v-for="(subItem, subIndex) in item.last4WeekField" v-if="subIndex != 0">
                                <td class="table-border-left" v-html="subItem.label.split('<div')[0]"></td>
                                <td>{{ getNumberofPeople(item.last4Week[0][subItem.key]) }}</td>
                                <td>{{ getNumberofPeople(item.last4Week[1][subItem.key]) }}</td>
                                <td>{{ getNumberofPeople(item.last4Week[2][subItem.key]) }}</td>
                                <td>{{ getNumberofPeople(item.last4Week[3][subItem.key]) }}</td>
                                <td>{{ getNumberofPeople(item.last4Week[4][subItem.key]) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="model-performance-1week">
                    <div class="describe">
                        {{$t("Share.PredictModelPerformanceNextWeek")}}
                    </div>
                    <table>
                        <thead v-if="item.lag1Backtest">
                            <tr class="model-name">
                                <td class="">{{$t("Share.ModelName")}}</td>
                                <td colspan="2" v-for="(subItem) in item.lag1Backtest">{{subItem.model}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>MAPE</td>
                                <td class="table-order-left">Hit Rate</td>
                                <td>MAPE</td>
                                <td class="table-order-left">Hit Rate</td>
                                <td>MAPE</td>
                                <td class="table-order-left">Hit Rate</td>
                                <td>MAPE</td>
                                <td class="table-order-left">Hit Rate</td>
                                <td>MAPE</td>
                                <td class="table-order-left">Hit Rate</td>
                            </tr>
                        </thead>
                        <tbody v-if="item.lag1Backtest">
                            <tr v-for="(sub1Item, sub1Index) in Week4Array">
                                <td class="table-border-left">{{sub1Item}}{{$t('Share.Week')}}</td>
                                <template v-for="(sub2Item, sub2Index) in item.lag1Backtest">
                                    <td>{{ getNumberofPercent(sub2Item[`mape_${sub1Item}`]) }}</td>
                                    <td>{{ getNumberofPercent(sub2Item[`hit_rate_${sub1Item}`]) }}</td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div class="col-sm-4 chart">
                <chartForecast 
                    isNeededShowLegend="true" 
                    :dataChartReal="item.chartReal" 
                    :dataChartForecast="item.chartForecast"
                    customWidth="350" customHeight="351" 
                    v-if="item.chartReal && item.chartForecast">
                </chartForecast>
            </div>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AllTWComponent from "./AllTWComponent";
import chartForecast from "./chartForecast";
import Vue from 'vue';
export default {
  name: 'AllTaiwan',
  components: {
    AllTWComponent,
    chartForecast
  },
  data () {
    return {
      window: window,
      Data:[
        {series: "RODS", label: this.$i18n.t("Visits.EmergencyVisit"), isReady: false, currentReadyObject: 0},
        {series: "NHI", label: this.$i18n.t('Visits.OutpatientVisit'), isReady: false, currentReadyObject: 0},
        {series: "RODS_NHI", label: this.$i18n.t('Visits.All'), isReady: false, currentReadyObject: 0},
      ],  
      lastUpdate: undefined,
      lastWeek: "...",
      WeekSelectValue: 52,
      Week4Array: [4, 8, 52],
      randomValue: Math.random(),
      simpleMode: true,
      currentMode: 'RODS_NHI',
      options: [
        {value:'RODS_NHI', text: '總就診人次', title: "來源：健保資料庫+RODS"},
        {value:'NHI', text: '門診', title: "來源：健保資料庫"},
        {value:'RODS', text: '急診', title: "來源：RODS"},
      ]
    }
  },
  methods: {
    getNumberofPeople: function(val){
        return d3.format(",.0f")(val);
    },
    getNumberofPercent: function(val){
        if(val == 1) return '100%';
        else return val===undefined ? "" : d3.format(".2%")(val);
    },
    getLastUpdate: function(){
      Vue.axios.get(`https://fluforecast.cdc.gov.tw/WebService/getFileUpdateTime.php`).then((res)=>{
        if(res.status != 200){

        }
        else{
            this.lastUpdate = res.data;
        }
      })
    },
    getLastWeek: function(){
        Vue.axios.get(`static/Data/Taiwan/RODS/Latest_4_Weeks_Forecast_Chart/real_value.csv?rand=${this.randomValue}`).then((res)=>{
            d3.csvParse(res.data, (d, i)=>{
                this.lastWeek = d.yearWeek.substring(4,6);
            })
        });
    },
    onWeekSelectValue: function(updatedWeekSelectValue){
      this.WeekSelectValue = updatedWeekSelectValue;
    },

    //Emit data
    getChartReal: function(d) {
      //console.warn("ChartReal",d.series)
      let obj = this.Data.find((v)=>{return d.series == v.series})
      obj.chartReal = d.data;
      obj.currentReadyObject++;

      if(obj.currentReadyObject == 4) obj.isReady = true;
    },
    getChartForecast: function(d) {
      //console.warn("ChartForecast",d.series)
      let obj = this.Data.find((v)=>{return d.series == v.series})
      obj.chartForecast = d.data;
      obj.last4WeekField = d.field;
      obj.currentReadyObject++;

      if(obj.currentReadyObject == 4) obj.isReady = true;
    },
    getLast4Week: function(d) {
      //console.warn("ChartLast4Week",d.series)
      let obj = this.Data.find((v)=>{return d.series == v.series})
      obj.last4Week = d.data;     
      obj.currentReadyObject++; 

      if(obj.currentReadyObject == 4) obj.isReady = true;
    },
    getLag1Backtest: function(d) {
      //console.warn("ChartLag1Backtest",d.series)
      let obj = this.Data.find((v)=>{return d.series == v.series})
      obj.lag1Backtest = d.data;
      obj.currentReadyObject++;

      if(obj.currentReadyObject == 4) obj.isReady = true;
    },
    print: function(){
      this.$ga.event({
        eventCategory: 'AllTaiwan',
        eventAction: 'Print'
      })
      window.print()
    }
  },
  mounted: function(){

        this.getLastUpdate();
        //this.getLastWeek();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../scss/_rwd.scss';

  .hide{
      @include xs-width(){
        display: none;
      }
  }

  .control-type-button{
      @include xs-width(){
          display: block;
      }
      @include sm-width(){
          display: block;
      }
      @include md-width(){
          display: none;
      }
      @include lg-width(){
          display: none;
      }
      @include xl-width(){
          display: none;
      }
  }
  .last-update{
      font-size: 14px;
  }

  *>.container-fluid {
    color: #FFF;
    max-width: 1920px;
    min-height: 80vh;
  }

  .row{
    margin: 8px 0px;
  }

  .container-fluid {
    padding: 0px;
  }

  hr{
      border-color: #a0a0a0;
      margin: 0 8px;
  }
  
  .controller{
      display: flex;
      justify-content: space-between;
      color: #FFF;

      font-size: 14px;
  }
  .controller .print:hover{
      color: #9e9e9e;
      border: 1px solid #9e9e9e;
  }
  .controller .print{
      display: flex;
      cursor: pointer;
      border: 1px solid #FFF;
      border-radius: 4px;
      padding: 4px;
  }

  .controller .print .material-icons{
      font-size: 20px;
      margin-right: 4px;
  }

  @media print{
    .container-fluid{
      display: none;
    }
    .print{
        font-size: 14px !important;
    }
    .btn{
        display: none;
    }
  }

  .print{
    display: none;
  }
  
  @page{
    margin: 16px 0 0 0;
    /** size: 11.69in 16.9in; **/
    size: A4;
  }
  @media  print {
    html, body {
        width: 210mm;
        height: 297mm;
    }

    .print{
      display: block;
      -webkit-print-color-adjust: exact;
      printer-colors: exact !important;
      color-adjust: exact !important;
      font-size: 15px;
    }
    thead { 
        display: table-row-group 
    }
  }

  .col-sm-8{
      padding: 0 8px;
  }

  .project-name .title{
      font-size: 30px;
      font-weight: bold;
      color: #000;

      padding-left: 8px;
  }

  .project-name .update-time{
      font-size: 14px;
      color: #000;

      padding-left: 8px;
  }

  td{
      padding: .3rem .3rem;
  }
  .project-name, .forecast-4-week-chart, .item{
      margin-bottom: 4px;
  }

  .item:not(:last-child){
      padding-bottom: 16px;
      border-bottom: 1px solid #bfbfbf;
  }

  .model-performance-1week{
      margin-top: 8px;
  }

  .model-performance-1week table .model-name td {
      font-size: 12px;
  }

  .item .title, .model-performance-1week .title{
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 4px;
      margin-top: 4px;

      padding-left: 8px;
      padding-right: 8px;
  }

  .item .describe, .model-performance-1week .describe{
      color: #4e4e4e;
      font-weight: 500;
  }
  
  
  .item .forecast-4-week-table table, .model-performance-1week table{
      width: 100%;
      text-align: right;
  }

  .item .forecast-4-week-table table thead tr td, .model-performance-1week table thead tr td{
      text-align: center;
      color: #000;
  }
  
  .model-performance-1week table thead tr:first-child td:not(:first-child){
      text-align: center;
  }

  .item .forecast-4-week-table table tbody tr td:first-child, .model-performance-1week table tbody tr td:first-child{
      text-align: left;
  }

  .item .forecast-4-week-table table tbody tr:last-child, .model-performance-1week table tbody tr:last-child{
      border-bottom: 1px solid #dee2e6;
  }

  .item .forecast-4-week-table table thead tr td, .model-performance-1week table thead tr td{
      background-color: #c4c5cc !important;
      font-size: 16px;
      font-weight: 600;
      color: #383838;
  }
  
  .model-performance-1week table thead tr:not(:first-child) td{
      font-size: 13px;
  }

  .item .forecast-4-week-table table tbody tr:nth-of-type(even):not(:first-child) td, .model-performance-1week table tbody tr:nth-of-type(even):not(:first-child)  td{
      background-color: rgba(0,0,0,.05) !important;
  }

  .table-border-left{
      border-right: 1px solid #dee2e6;
  }

  .axis .domain, .axis .tick > line {
      stroke: #cacaca;
  }
  .axis .tick text {
      font-size: 14px;
      fill: #848484;
  }
  .axis .tick .year {
      fill: #000;
      font-size: 18px;
      font-weight: bold;
  }
  .path {
      fill: none;
      stroke-width: 2px;
  }
  .path.path_forecast {
      stroke: rgba(0, 0, 0, 0.35);
      stroke-dasharray: 4, 4;
      stroke-width: 3px;
  }
  .path.path_Ensemble {
      stroke: #E35959;
      stroke-width: 6px;
      stroke-dasharray: 5, 8;
  }
  .path.path_real {
      stroke: #9E9E9E;
  }
  .path.path_Arima {
      stroke: rgba(32, 123, 180, 0.7);
  }
  .path.path_SVR {
      stroke: rgba(161, 214, 81, 0.7);
  }
  .path.path_RF {
      stroke: rgba(103, 186, 91, 0.7);
  }
  .path.path_XGB {
      stroke: rgba(118, 194, 200, 0.7);
  }
  .circle_Ensemble {
  fill: #FFF;
  stroke: #E35959;
  stroke-width: 3px;
  }
  .circle_Ensemble.first {
  stroke: #9E9E9E;
  }
  .lineCursor {
  stroke-width: 1;
  stroke: #9e9e9e;
  }
</style>

<style lang="scss" scoped>
  .control-button{
      &.text-center{
          padding-top: 18px;
      }
      button{
          display: inline-flex;
              
          background: rgba(0,0,0,0);
          color: #FFF;
          font-size: 14px;
          border-color: #FFF;
          border-radius: 50px;
          i{
            font-size: 20px;
            padding-right: 4px;
          }

          &:hover{
              background-color: #FFF;
              color: #000;
              i{
                color: #000;
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/AllTaiwan.vue